/* global Forms, ReactOnRails */

import ApplicationController from '../application_controller'

class RelatedTasksController extends ApplicationController {
  connect () {
    ReactOnRails.reactOnRailsPageLoaded()
  }
}

export default RelatedTasksController
